// src/pages/tasks/DrawerTriggerPage.jsx
import React, { useEffect } from 'react';
import { useParams, useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';

import useTaskStore from '../../stores/taskStore';
import TaskDetailDrawer from '../../components/tasks/TaskDetailDrawer';

/**
 * DrawerTriggerPage - Opens the TaskDetailDrawer for task creation
 * Uses existing task store mechanisms without modifications
 */
const DrawerTriggerPage = ({ mode = 'create' }) => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const projectId = searchParams.get('projectId');
  
  // Get store methods
  const { 
    openTaskDrawer, 
    isTaskDrawerOpen, 
    closeTaskDrawer 
  } = useTaskStore();
  
  // Open drawer when component mounts
  useEffect(() => {
    // For create mode, just open the drawer with no task ID
    if (mode === 'create') {
      openTaskDrawer(null);
    } 
    // For edit mode, open with the task ID
    else if (mode === 'edit' && id) {
      openTaskDrawer(id);
    }
  }, [mode, id, openTaskDrawer]);
  
  // Navigate back when drawer closes
  useEffect(() => {
    const unsubscribe = useTaskStore.subscribe(
      state => state.isTaskDrawerOpen,
      isOpen => {
        if (!isOpen) {
          // Navigate back to appropriate page when drawer closes
          if (location.state?.from) {
            navigate(location.state.from);
          } else {
            navigate('/tasks');
          }
        }
      }
    );
    
    return unsubscribe;
  }, [navigate, location.state]);
  return null;
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <CircularProgress />
      {/* Drawer will be rendered and controlled by store state */}
      {/* <TaskDetailDrawer /> */}
    </Box>
  );
};

export default DrawerTriggerPage;